import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { faCloudArrowDown, faLeft, faShare, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import BtnDownloadPdf from 'components/desktop/_general/Button/BtnDownloadPdf/BtnDownloadPdf';
import BtnSave from 'components/desktop/_general/Button/BtnSave/BtnSave';
import BtnShoppingCart from 'components/desktop/_general/Button/BtnShoppingCart/Index';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ImageWithFallback2 from 'components/desktop/_general/Image/ImageWithFallback2';
import ENTITLEMENTS from 'enums/entitlements';
import { getPicturePath } from 'functions/getPicturePath';
import * as Image from 'types/Media/Image';
import EntityType from 'types/ShoppingCart/EntityType';

interface IProps {
	handleSave: () => void;
	title: string;
	image: Image.Type | null;
	isLoading: boolean;
	readOnly: boolean;
	bottomArea: JSX.Element;
	handleToggleOverlay?: () => void;
	id?: string;
	setDisplayOverlay?: (input: boolean) => void;
	entityType?: EntityType;
}

const DetailHeader = (props: IProps) => {
	const { t } = useTranslation();

	const renderImage = (): JSX.Element | null => {
		if (!props.image) {
			return (
				<div className="d-flex justify-content-center align-items-center">
					<FontAwesomeIcon size="4x" icon={faCamera} style={{ color: 'white' }} />
				</div>
			);
		}

		return (
			<ImageWithFallback2
				src={getPicturePath(props.image, 230)}
				alt="thumbnail"
				style={{
					height: '100%',
					width: 'auto',
					objectFit: 'cover',
					objectPosition: 'center',
					display: 'block',
				}}
				placeholderStyle={{
					backgroundColor: 'grey',
					width: '100%',
					maxWidth: '12rem',
					aspectRatio: '1/1',
					height: 'auto',
					borderRadius: '2rem', // match border radius for smooth transition
				}}
				iconSize="4x"
			/>
		);
	};

	const renderTopArea = (): JSX.Element => {
		return (
			<RenderIf condition={!props.readOnly}>
				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: '0.4rem',
					}}
				>
					<RenderIf
						condition={[
							EntityType.RECIPE,
							EntityType.MENU,
							EntityType.MENUPLAN,
						].includes(props.entityType as EntityType)}
					>
						<div>
							<BtnShoppingCart
								id={props.id ?? null}
								entityType={props.entityType as EntityType}
							/>
						</div>
					</RenderIf>
					{props.setDisplayOverlay && (
						<div>
							<BtnDownloadPdf
								setDisplayOverlay={props.setDisplayOverlay}
								id={props.id}
							/>
						</div>
					)}
					<RenderIf
						entitlements={[ENTITLEMENTS.URL_ANALYSIS]}
						condition={Boolean(props.handleToggleOverlay)}
					>
						<div>
							<button
								type="button"
								style={{ width: '2.5rem', height: '2.5rem', fontSize: '0.8rem' }}
								className="btn btn-outline-secondary"
								onClick={props.handleToggleOverlay}
							>
								<FontAwesomeIcon icon={faCloudArrowDown as IconProp} />
							</button>
						</div>
					</RenderIf>

					<div>
						<BtnSave
							handleSave={() => props.handleSave()}
							isLoading={props.isLoading}
						/>
					</div>
				</div>
			</RenderIf>
		);
	};

	const navigate = useNavigate();

	return (
		<>
			<div className="d-flex justify-content-between" style={{ width: '100%' }}>
				<button
					className="btn btn-outline-light btn-sm"
					style={{ color: '#6B71CC' }}
					onClick={() => navigate('/recipe/search')}
				>
					<FontAwesomeIcon icon={faLeft} /> Back to Recipes
				</button>
				<div style={{ display: 'flex', justifyContent: 'center' }}>{renderTopArea()}</div>
			</div>
			<div
				className="d-flex flex-column align-items-center"
				style={{
					marginTop: '1rem',
					width: '100%',
				}}
			>
				{/* <fieldset
					style={{
						padding: '0',
						boxShadow: 'none',
						borderRadius: '2rem 2rem 2rem 2rem',
						backgroundColor: 'rgb(246 247 255)',
						width: '100%',
					}}
				>
					<div className="d-flex align-items-center">
						<div
							className="d-flex align-items-center"
							style={{
								borderRadius: '2rem 2rem 2rem 2rem',
								color: 'white',
								backgroundImage:
									'linear-gradient(-45deg, #6066C1 0%, #99a1fd 100%)',
								boxShadow: '0 0.2rem 4px 2px rgb(0 0 0 / 8%)',
								width: '55%',
							}}
						>
							{renderImage()}
							<div style={{ marginLeft: '3rem', marginRight: '3rem' }}>
								<div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
									{props.title}
								</div>
							</div>
						</div>
						<div
							className="d-flex flex-column justify-content-between"
							style={{ width: '45%', marginLeft: '2rem', marginRight: '2rem' }} // changed from flexGrow: '1'
						>
							{props.bottomArea}
						</div>
					</div>
				</fieldset> */}
				<fieldset
					style={{
						padding: '0',
						boxShadow: 'none',
						borderRadius: '2rem 2rem 2rem 2rem',
						backgroundColor: 'rgb(246 247 255)',
						width: '100%',
					}}
				>
					<div className="d-flex align-items-center">
						<div
							style={{
								position: 'relative',
								overflow: 'hidden',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								borderRadius: '2rem',
								boxShadow: '0 0.2rem 4px 2px rgb(0 0 0 / 8%)',
							}}
						>
							{renderImage()}
						</div>
						<div style={{ width: '80%' }}>{props.bottomArea}</div>
					</div>
				</fieldset>
			</div>
		</>
	);
};

export default DetailHeader;
